<template>
  <div>
    <div
      v-b-popover.hover.topright.html="getSpan( data.item.sub_certificate_name , 'edit sub certificate' )"
      style="height: 100% !important; display: flex; align-items: center; justify-content: center;"
      class="hover-pointer"
      @click="
        $router.push({
          name: 'edit-sub-certificate',
          params: { id: data.item.id }
        })
      "
    >
      <span style="font-size: smaller;">
        {{ getSmallName(data.item.sub_certificate_name) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubCertificateCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    getSmallName: {
      type: Function,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
  },
}
</script>
